import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Paths
import { Podium } from './IconPaths';

const DEBUG = false;

class PodiumIcon extends React.Component {
  constructor(props) {
    super(props);

    this._icon = null;
  }
  _initAnimations() {

    const circle1 = this._icon.querySelector('#podium-circle-1');
    const circle2 = this._icon.querySelector('#podium-circle-2');
    const circle3 = this._icon.querySelector('#podium-circle-3');

    const rect1 = this._icon.querySelector('#podium-rect-1');
    const rect2 = this._icon.querySelector('#podium-rect-2');
    const rect3 = this._icon.querySelector('#podium-rect-3');

    const rect1EndData = this._icon.querySelector('#podium-rect-1a').getAttribute('d');
    const rect2EndData = this._icon.querySelector('#podium-rect-2a').getAttribute('d');
    const rect3EndData = this._icon.querySelector('#podium-rect-3a').getAttribute('d');

    TweenMax.to(rect1, 0.5, {
      morphSVG: rect1EndData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true,
      delay: 0.5
    });

    TweenMax.to(rect2, 0.5, {
      morphSVG: rect2EndData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true,
      delay: 0.5
    });

    TweenMax.to(rect3, 0.5, {
      morphSVG: rect3EndData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true,
      delay: 0.5
    });

    TweenMax.set(circle1, { scaleY: 0.9, y: 3 });
    TweenMax.to(circle1, 0.5, {
      y: -10,
      scaleY: 1,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

    TweenMax.set(circle2, { scaleY: 0.85, y: 0 });
    TweenMax.to(circle2, 0.5, {
      y: -20,
      scaleY: 1,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

    TweenMax.set(circle3, { scaleY: 0.9, y: 4 });
    TweenMax.to(circle3, 0.5, {
      y: -5,
      scaleY: 1,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

  }
  componentDidMount() {
    this._initAnimations();
  }
  render() {
    const { colors, height, width, nodeColors, strokeColor } = this.props;
    const baseIconColor = colors.length > 1 ? colors[1] : colors[0];

    return (
      <svg viewBox='0 0 100 100' width={width} height={height}>
        <g ref={icon => { this._icon = icon; }}>
          <Podium transform={'translate(0, 0)'} fill={baseIconColor} nodeColors={nodeColors} strokeColor={strokeColor} />
        </g>
      </svg>
    );
  }
};

PodiumIcon.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  nodeColors: PropTypes.arrayOf(PropTypes.string),
  strokeColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

PodiumIcon.defaultProps = {
  colors: ['black'],
  nodeColors: ['black', 'black', 'black'],
  strokeColor: 'white',
  width: 200,
  height: 200
};

export default PodiumIcon;



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/PodiumIcon.jsx